/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateCompanyConfigRequest model module.
* @module model/UpdateCompanyConfigRequest
* @version 2020-12-7
*/
export default class UpdateCompanyConfigRequest {
    /**
    * Constructs a new <code>UpdateCompanyConfigRequest</code>.
    * @alias module:model/UpdateCompanyConfigRequest
    * @class
    * @param order {Array.<Number>} オーダー
    */

    constructor(order) {
        
        
        this['order'] = order;
        
    }

    /**
    * Constructs a <code>UpdateCompanyConfigRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateCompanyConfigRequest} obj Optional instance to populate.
    * @return {module:model/UpdateCompanyConfigRequest} The populated <code>UpdateCompanyConfigRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateCompanyConfigRequest();
                        
            
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], ['Number']);
            }
        }
        return obj;
    }

    /**
    * オーダー
    * @member {Array.<Number>} order
    */
    'order' = undefined;




}
